import React from 'react';

const Logo = ({ alt, src, width, height , className}) => {
  return (
    <img src='/logonew.png' alt={alt} width={width} height={height} className={className} /> 
  );
};

export default Logo; 